var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "104.35 122.49 491.3 313.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m104.37 279.12c-0.19531 3.6758 0.78516 7.4531 3.0078 10.746 52.746 77.312 142.05 145.86 242.62 145.86s189.88-68.551 242.62-145.86c2.2227-3.293 3.2031-7.0703 3.0078-10.746 0.19531-3.6914-0.78516-7.4727-3.0078-10.746-52.746-77.332-142.05-145.88-242.62-145.88s-189.88 68.547-242.62 145.88c-2.2227 3.2734-3.2031 7.0547-3.0078 10.746zm245.63-86.625c-48.301 0-87.5 39.199-87.5 87.5s39.199 87.5 87.5 87.5 87.5-39.199 87.5-87.5-39.199-87.5-87.5-87.5zm0 35c28.98 0 52.5 23.52 52.5 52.5s-23.52 52.5-52.5 52.5-52.5-23.52-52.5-52.5 23.52-52.5 52.5-52.5z",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/icon-eye.7b2e462c758be30e1e6c870bd556d0e5.svg";
export { ForwardRef as ReactComponent };